import http from '../../../../api/http';

export interface ClienteSearch {
  id: number;
  codigo: string;
  razonSocial: string;
  nombreFantasia?: string;
  nroIdentificacion?: string;
}

export const clienteService = {
  async search(term: string): Promise<ClienteSearch[]> {
    const response = await http.get(`/catalog/clientes/search?term=${encodeURIComponent(term)}`);
    return response.data;
  }
};
